export interface IRace {
  code: string;
  description: string;
}

export const Races: IRace[]= [
  {
    code: 'CN',
    description: 'Chinese'
  },
  {
    code: 'MY',
    description: 'Malay'
  },
  {
    code: 'IN',
    description: 'Indian'
  },
  {
    code: 'others',
    description: 'Others'
  },
]